import React from "react";
import "./Hashtags.scss";
const Hashtags = ({ hashtags, tagHandler }) => {
  return (
    <div className="nav2">
      {hashtags.map((value, index) => {
        return (
          <div className="card" key={index}>
            <div
              className={`card-body ${
                value.selected
                  ? value.selected == true
                    ? "selected"
                    : "unselected"
                  : ""
              }`}
              onClick={() => tagHandler(value.id)}
              style={{ cursor: "pointer" }}
            >
              <div>#{value.title} </div>
              <div className="number">
                <span style={{ margin: "15px" }}> {value.tag_count}</span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Hashtags;
